export default "__VITE_ASSET__C6FwBcQS__"